import { render, staticRenderFns } from "./IndexLayout.vue?vue&type=template&id=61d3b7f8&"
import script from "./IndexLayout.vue?vue&type=script&lang=js&"
export * from "./IndexLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports